'use client';

import React from 'react';
import MessageBubble from './MessageBubble';
import { Message } from './types';

interface MessageGroupProps {
  messages: Message[];
  senderId: 'me' | 'alex';
  isSelecting: boolean;
  selectedIds: Set<string>;
  onToggleSelect: (id: string) => void;
  onContextMenu: (msgId: string, x: number, y: number) => void;
  onReply: (msg: Message) => void;
  editingMessageId?: string | null;
  onSaveEdit?: (msgId: string, newText: string) => void;
  onCancelEdit?: () => void;
}

export default function MessageGroup({
  messages,
  senderId,
  isSelecting,
  selectedIds,
  onToggleSelect,
  onContextMenu,
  onReply,
  editingMessageId,
  onSaveEdit,
  onCancelEdit,
}: MessageGroupProps) {
  const isMe = senderId === 'me';
  const count = messages.length;

  return (
    <div className={`flex ${isMe ? 'flex-row-reverse' : 'flex-row'} items-end mb-1`}>
      <div className={`flex flex-col gap-[3px] ${isMe ? 'items-end' : 'items-start'} max-w-[78%] sm:max-w-[68%] lg:max-w-[60%]`}>
        {messages.map((msg, idx) => {
          const isFirst = idx === 0;
          const isLast = idx === count - 1;
          return (
            <MessageBubble
              key={msg.id}
              message={msg}
              isMe={isMe}
              isFirst={isFirst}
              isLast={isLast}
              isSelecting={isSelecting}
              isSelected={selectedIds.has(msg.id)}
              onToggleSelect={onToggleSelect}
              onContextMenu={onContextMenu}
              onReply={onReply}
              isEditing={editingMessageId === msg.id}
              onSaveEdit={onSaveEdit}
              onCancelEdit={onCancelEdit}
            />
          );
        })}
      </div>
    </div>
  );
}